import { LOCALIZED_VALIDATION_PATTERNS } from '../../constants/validationPatterns';
import patternInputValidation from '../../lib/patternInputValidation';
import { requestOrderData } from '../orderInfo';

export const GENERATE_LANDING_PAGE_FORM = 'GENERATE_LANDING_PAGE_FORM';
export const UPDATE_LANDING_FORM_INPUT = 'UPDATE_LANDING_FORM_INPUT';

export const mapUrlParamsToFormInputs = (initialPageLoadParams) => {
  const {
    order: number = null,
    gift = false,
    bzip = null,
    dzip = null,
    email = null,
  } = initialPageLoadParams;

  return {
    number,
    email,
    zip: gift ? dzip : bzip,
  };
};

export const updateLandingFormInput = (inputKey, inputValue = null) => ({
  type: UPDATE_LANDING_FORM_INPUT,
  data: {
    inputKey,
    inputValue,
  },
});

export const generateLandingPageForm = () => (dispatch, getState) => {
  const {
    page: { productType, locale, initialPageLoadParams } = {},
    returnsSettings: {
      [productType]: {
        validation: { input_controls: inputControls = [] } = {},
        validationPatterns: { [locale]: localizedValidationPatternsFromSettings = null } = {},
      } = {},
    } = {},
  } = getState();

  // Currently, there are two data structures for validating landing inputs:
  // 1. Per-input validation for Neiman Marcus brands and master JSON ("patterns")
  // 2. Per-product + per-locale validation to be used in the future ("validationPatterns")
  // This code assumes a retailer cannot have both -- Ideally, structure 1 should be deprecated
  const validationPatterns = {};
  const prepopulatedInputs = mapUrlParamsToFormInputs(initialPageLoadParams);
  const { [productType]: { [locale]: defaultPatternsForLocale = {} } = {} } =
    LOCALIZED_VALIDATION_PATTERNS;

  const mergedLocalizedValidationPatterns = localizedValidationPatternsFromSettings && {
    ...defaultPatternsForLocale,
    ...localizedValidationPatternsFromSettings,
  };

  const landingForm = inputControls.reduce((parsedInputRows, nextInputRow) => {
    const nextInputRowKeys = nextInputRow.reduce((allInputs, nextInput) => {
      const { name, patterns = null } = nextInput;

      if (patterns) validationPatterns[name] = patterns;

      return {
        ...allInputs,
        [name]: prepopulatedInputs[name] || null,
      };
    }, {});

    return {
      ...parsedInputRows,
      ...nextInputRowKeys,
    };
  }, {});

  dispatch({
    type: GENERATE_LANDING_PAGE_FORM,
    data: {
      landingForm,
      validationPatterns,
      localizedValidationPatterns: mergedLocalizedValidationPatterns,
    },
  });
};

export const validateFormData = (state) => {
  const {
    landingPage: {
      landingForm = {},
      validationPatterns = {},
      localizedValidationPatterns = null,
    } = {},
  } = state;

  const formKeys = Object.keys(landingForm);

  const localizedValidation =
    localizedValidationPatterns &&
    formKeys.every((inputKey) => {
      const { [inputKey]: inputValue } = landingForm;
      const { [inputKey]: { pattern, validationDisabled = false } = {} } =
        localizedValidationPatterns;

      if (validationDisabled) return true;

      return patternInputValidation(inputValue, pattern);
    });

  const perInputValidation = formKeys.every((inputKey) => {
    const { [inputKey]: inputValue } = landingForm;
    const { [inputKey]: pattern = null } = validationPatterns;

    return patternInputValidation(inputValue, pattern);
  });

  return localizedValidationPatterns ? localizedValidation : perInputValidation;
};

export const submitLandingForm = () => async (dispatch, getState) => {
  const isValidFormData = validateFormData(getState());

  // TODO: Hook this up to error state
  if (!isValidFormData) return null;

  await dispatch(requestOrderData());

  return isValidFormData;
};
